import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1730750a")

_pushScopeId("data-v-1730750a")
const _hoisted_1 = {
  id: "myModal",
  class: "h-auto w-11/12 md:w-1/2 p-5 bg-white rounded-md"
}
const _hoisted_2 = { class: "flex flex-col w-full h-auto" }
const _hoisted_3 = { class: "flex w-full h-auto justify-center items-center" }
const _hoisted_4 = { class: "flex w-10/12 h-auto py-3 justify-center items-center text-2xl font-bold" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", {
  onclick: "document.getElementById('myModal').close();",
  class: "flex w-1/12 h-auto justify-center cursor-pointer"
}, [
  /*#__PURE__*/_createVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#000000",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    class: "feather feather-x"
  }, [
    /*#__PURE__*/_createVNode("line", {
      x1: "18",
      y1: "6",
      x2: "6",
      y2: "18"
    }),
    /*#__PURE__*/_createVNode("line", {
      x1: "6",
      y1: "6",
      x2: "18",
      y2: "18"
    })
  ])
], -1)
const _hoisted_6 = { class: "flex w-full h-full py-10 px-2 justify-center bg-gray-200 rounded text-gray-500" }
_popScopeId()


export default _defineComponent({
  expose: [],
  setup(__props) {


return /*#__PURE__*/_withId((_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode("dialog", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "title"),
            _renderSlot(_ctx.$slots, "Querytitle"),
            _renderSlot(_ctx.$slots, "Racetitle")
          ]),
          _hoisted_5
        ]),
        _createVNode("div", _hoisted_6, [
          _renderSlot(_ctx.$slots, "markdown"),
          _renderSlot(_ctx.$slots, "Querydesc"),
          _renderSlot(_ctx.$slots, "Racedesc")
        ])
      ])
    ])
  ]))
})
}

})